import { IFormFile} from '@proxy/microsoft/asp-net-core/http'
export interface FormFile extends IFormFile {

}
